import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FaUserPlus } from 'react-icons/fa';
import { YButton } from '../../../ui/YButton';
import { ProPanel } from '../../pro/ProPanel';
import { RequestClubMembershipDialog } from './RequestClubMembershipDialog';
import './FindClubCardActions.css';

export function FindClubCardActions({ club, layout = 'inline' }) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [proRequired, setProRequired] = useState(false);
  const canRequest = Boolean(club.id);

  if (proRequired) {
    return <ProPanel onDismiss={() => setProRequired(false)} />;
  }

  return (
    <>
      <div className={`find-club-actions find-club-actions--${layout}`}>
        {club.require_approval_to_join ? (
          <p className="find-club-actions__hint">
            This club reviews join requests. Send an introduction to the president.
          </p>
        ) : (
          <p className="find-club-actions__hint">
            Request membership or ask the president for an invite code.
          </p>
        )}
        <YButton
          type="button"
          variant="primary"
          size="sm"
          disabled={!canRequest}
          onClick={() => setDialogOpen(true)}
          data-testid={`find-club-request-${club.id}`}
        >
          <FaUserPlus aria-hidden />
          ASK TO JOIN
        </YButton>
      </div>
      <RequestClubMembershipDialog
        show={dialogOpen}
        onHide={() => setDialogOpen(false)}
        onProRequired={() => {
          setDialogOpen(false);
          setProRequired(true);
        }}
        clubId={club.id}
        clubName={club.name}
        requireApproval={Boolean(club.require_approval_to_join)}
      />
    </>
  );
}

FindClubCardActions.propTypes = {
  club: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string,
    require_approval_to_join: PropTypes.bool,
  }).isRequired,
  layout: PropTypes.oneOf(['inline', 'stacked']),
};
